import * as e from "react";
import { forwardRef as l } from "react";
const n = l(function(r, C) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: C,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...r
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M22 13.6514V16.1009C22 17.4003 21.4732 18.6463 20.5355 19.5651C19.5979 20.4839 18.3261 21 17 21H7C5.67392 21 4.40215 20.4839 3.46447 19.5651C2.52678 18.6463 2 17.4003 2 16.1009L2 13.6514H22ZM14.7433 3.03025L14.7992 3.0425C15.3992 3.15926 15.885 3.59119 16.0658 4.15703L18.9792 9.15081C19.612 9.41885 20.1816 9.81184 20.6524 10.3052C21.1233 10.7986 21.4853 11.3818 21.7158 12.0184H2.285C2.97083 10.1159 4.82333 8.75235 7 8.75235H14.9067L13.4667 6.28322L6.2025 6.32813C5.77009 6.33249 5.35288 6.172 5.03899 5.88057C4.7251 5.58914 4.5391 5.18958 4.52028 4.76627C4.50145 4.34297 4.65128 3.92908 4.93812 3.612C5.22496 3.29493 5.62634 3.0995 6.0575 3.06699L6.1825 3.06209L14.2133 3.0131C14.3898 2.99107 14.5687 2.99686 14.7433 3.03025Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  n as Curling
};
